module.exports = "/assets/data/b0b645526cdc071114c040ab3e7fe5dc-G52.data.json";